import React, { useState, useEffect } from 'react';
import styles from './companySettingModal.module.scss';
import { Container, Col, Modal, Button } from 'react-bootstrap';
import AddVacancyConfiguration from './vacancyConfiguration';
import AddLogoConfiguration from './logoConfiguration';
import AddDescriptionConfiguration from './descriptionConfiguration';

function CompanySettingModal(props){
    
    let [step, setStep] = useState(1);
    let [companyDetails, setCompanyDetails] = useState({
        description: '',
        pageURL: '',
        companyLogo: []
    })

    function nextPage(value) {
        setStep(value)
    }
    function previousPage(value) {
        setStep(value)
    }

    function setCompanyDesc(value) {
        setCompanyDetails((prevState) => ({
            ...prevState,
            description: value.companyDesc

        }))
    }

    function setCompanyPageURL(value) {
        setCompanyDetails((prevState) => ({
            ...prevState,
            companyLogo: value.pageURL

        }))
    }

    function setCompanyLogo(value) {
        setCompanyDetails((prevState) => ({
            ...prevState,
            companyLogo: value.companyLogo
        }))
    }


    useEffect(() => {
        let unmounted = false;
        return () => { unmounted = true };
    }, []);

    return (
        <div>
            <Modal
                show={props.show}
                backdrop="static"
                keyboard={false}
                centered
                size="md"
            >
                <Modal.Body className={styles.modalBodyWrapper} id='account_setup_modal'>
                    <div className={styles.modalCancelBtnDiv}>
                    </div>
                    <div className={styles.modalHeaderDiv}>
                        <h2 className={styles.modalHeader}>Account Setup</h2>
                    </div>
                    <Col sm={{ span: 4, offset: 4 }} className={styles.stepPosition}>

                        <div className={step === 1 ? `${styles.roundStepMainDiv}` : step === 2 ? `${styles.roundStepMainDiv} ${styles.roundStepMainDiv2}` : step === 3 ? `${styles.roundStepMainDiv} ${styles.roundStepMainDiv3}` : `${styles.roundStepMainDiv}`}>
                            <div className={styles.stepActive}>
                                {
                                    step === 1 ?
                                        <svg className={styles.svgRound} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="Content">
                                                <rect width="24" height="24" rx="12" fill="#ECFAFD" />
                                                <circle id="Dot" cx="12" cy="12" r="4" fill="#2DA6C0" />
                                            </g>
                                        </svg>
                                        :
                                        <svg width="24" height="24" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_613_29628)">
                                                <rect y="0.5" width="24" height="24" rx="12" fill="#ECFAFD" />
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0965 7.89004L9.9365 14.8L8.0365 12.77C7.6865 12.44 7.1365 12.42 6.7365 12.7C6.3465 12.99 6.2365 13.5 6.4765 13.91L8.7265 17.57C8.9465 17.91 9.3265 18.12 9.7565 18.12C10.1665 18.12 10.5565 17.91 10.7765 17.57C11.1365 17.1 18.0065 8.91004 18.0065 8.91004C18.9065 7.99004 17.8165 7.18004 17.0965 7.88004V7.89004Z" fill="#2DA6C0" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_613_29628">
                                                    <rect y="0.5" width="24" height="24" rx="12" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                }

                            </div>
                            <div className={(step === 2) || (step === 3)  ? styles.stepActive : ''}>
                                {
                                    step === 2 ?
                                        <svg className={styles.svgRound} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="Content">
                                                <rect width="24" height="24" rx="12" fill="#ECFAFD" />
                                                <circle id="Dot" cx="12" cy="12" r="4" fill="#2DA6C0" />
                                            </g>
                                        </svg>
                                        :
                                        (step === 2) || (step === 3) ?
                                            <svg width="24" height="24" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_613_29628)">
                                                    <rect y="0.5" width="24" height="24" rx="12" fill="#ECFAFD" />
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0965 7.89004L9.9365 14.8L8.0365 12.77C7.6865 12.44 7.1365 12.42 6.7365 12.7C6.3465 12.99 6.2365 13.5 6.4765 13.91L8.7265 17.57C8.9465 17.91 9.3265 18.12 9.7565 18.12C10.1665 18.12 10.5565 17.91 10.7765 17.57C11.1365 17.1 18.0065 8.91004 18.0065 8.91004C18.9065 7.99004 17.8165 7.18004 17.0965 7.88004V7.89004Z" fill="#2DA6C0" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_613_29628">
                                                        <rect y="0.5" width="24" height="24" rx="12" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            :
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_613_29582)">
                                                    <rect width="24" height="24" rx="12" fill="#F9FAFB" />
                                                    <circle cx="12" cy="12" r="4" fill="#D0D5DD" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_613_29582">
                                                        <rect width="24" height="24" rx="12" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                }
                            </div>
                            <div className={(step === 3) ? styles.stepActive : ''}>
                                {
                                    step === 3 ?
                                        <svg className={styles.svgRound} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="Content">
                                                <rect width="24" height="24" rx="12" fill="#ECFAFD" />
                                                <circle id="Dot" cx="12" cy="12" r="4" fill="#2DA6C0" />
                                            </g>
                                        </svg>
                                        :
                                        (step === 3) ?
                                            <svg width="24" height="24" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_613_29628)">
                                                    <rect y="0.5" width="24" height="24" rx="12" fill="#ECFAFD" />
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0965 7.89004L9.9365 14.8L8.0365 12.77C7.6865 12.44 7.1365 12.42 6.7365 12.7C6.3465 12.99 6.2365 13.5 6.4765 13.91L8.7265 17.57C8.9465 17.91 9.3265 18.12 9.7565 18.12C10.1665 18.12 10.5565 17.91 10.7765 17.57C11.1365 17.1 18.0065 8.91004 18.0065 8.91004C18.9065 7.99004 17.8165 7.18004 17.0965 7.88004V7.89004Z" fill="#2DA6C0" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_613_29628">
                                                        <rect y="0.5" width="24" height="24" rx="12" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            :
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_613_29582)">
                                                    <rect width="24" height="24" rx="12" fill="#F9FAFB" />
                                                    <circle cx="12" cy="12" r="4" fill="#D0D5DD" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_613_29582">
                                                        <rect width="24" height="24" rx="12" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                }
                            </div>
                        </div>
                    </Col>
                    <Col sm={12} className={styles.colWithNoSidePaddings}>
                        <Container className={styles.colWithNoSidePaddings}>
                            <p className={styles.stepSubtopicPara}><span className={styles.stepSubtopicName}>
                                {
                                    step === 1 ? 'Upload Company Logo'
                                        : step === 2 ? 'Company Description'
                                         : step === 3 ? 'Apply Form Page URL'
                                            : null
                                }
                                </span>
                            </p>
                        </Container>
                    </Col>
                    <Col sm={12} className={styles.colWithNoSidePaddings}>
                        <Container className={styles.colWithNoSidePaddings}>
                            {/* Rendering Content Goes Here */}
                            {step === 1 && props.show === true && <AddLogoConfiguration nextPage={nextPage} setCompanyLogo={setCompanyLogo} companyDetails={companyDetails} />}
                            {step === 2 && props.show === true && <AddDescriptionConfiguration previousPage={previousPage} setCompanyDesc={setCompanyDesc} nextPage={nextPage} companyDetails={companyDetails}/>}
                            {step === 3 && props.show === true && <AddVacancyConfiguration previousPage={previousPage} setCompanyPageURL={setCompanyPageURL} companyDetails={companyDetails} handleClose={props.handleClose}/>}
                        </Container>
                    </Col>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default CompanySettingModal;